module.exports = __webpack_public_path__ + "static/media/가업승계.34883d61.png";